/**
 * @deprecated This component has been replaced by the Navbar component
 * which now handles both desktop (top navbar) and mobile (bottom bar) navigation.
 * 
 * The Navbar component automatically switches between layouts based on screen size.
 * Keep this file for backwards compatibility but it returns null.
 */

const BottomTabs = () => {
    return null
}

export default BottomTabs


